import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../assets/threadheads-tommy-loading-animation.json';
const LottieAnim = () => {
    return (React.createElement(Lottie, { animationData: animationData, loop: true }));
};
export default LottieAnim;
